import { actions, createAction, props } from '@ngneat/effects';
import { IStopInput, Stop } from '@data/stop/stop.model';
import { MatchingSession } from '@data/session/session.model';

/**
 * Organizer-side Stop actions (Akita + @ngneat/effects), mirroring the legacy Attendant
 * actions but for the single collapsed Stop entity. Handled by {@link StopEffects}, which
 * must be registered in `EffectsNgModule.forRoot([...])` (app.module) or these never run.
 */
export namespace StopActions {
  const NAMESPACE = 'Stop';

  export const TYPES = {
    load: '[' + NAMESPACE + '] Load stops for the session id',
    create: '[' + NAMESPACE + '] Create a stop',
    update: '[' + NAMESPACE + '] Update a stop by id',
    delete: '[' + NAMESPACE + '] Delete a stop by id',
    deleteMany: '[' + NAMESPACE + '] Delete many stops',
  } as const;

  export const load = createAction(TYPES.load, props<{ id: string }>());
  export const create = createAction(TYPES.create, props<{ input: IStopInput }>());
  export const update = createAction(
    TYPES.update,
    props<{ targetId: string; input: Partial<IStopInput> }>(),
  );
  export const deleteStop = createAction(TYPES.delete, props<{ targetId: string }>());
  export const deleteMany = createAction(TYPES.deleteMany, props<{ stops: Stop[] }>());

  export const loadStops = (id: MatchingSession['id']): void => {
    actions.dispatch(load({ id }));
  };

  export const createStop = (input: IStopInput): void => {
    actions.dispatch(create({ input }));
  };

  export const updateStop = (targetId: Stop['id'], input: Partial<IStopInput>): void => {
    actions.dispatch(update({ targetId, input }));
  };

  export const removeStop = (targetId: Stop['id']): void => {
    actions.dispatch(deleteStop({ targetId }));
  };

  export const removeManyStops = (stops: Stop[]): void => {
    actions.dispatch(deleteMany({ stops }));
  };
}
